import {Injectable, Injector} from '@angular/core';
import {CommodityModel} from '@shared/models/commodity.model';
import {Utilities} from '@shared/utilities/utilities.model';
import {RequestOptionsArgs, Response} from '@angular/http';
import {InnerMessageAuthorityMessageCode} from './inner-message-authority-utilities';
import {MessageComponentType, MessageDetail, MessageType} from '@shared/service/message-manager/message.model';
import {MessageManagerUtilities} from '@shared/service/message-manager/message-manager-utilities';
import {AuthorityBaseService} from './authority-base.service';
import {Observable, throwError} from 'rxjs';
import {OrderSummary} from '../models/order-summary.model';
import {catchError, map, tap} from 'rxjs/operators';
import { DossierModel } from '../models/dossier.model';

@Injectable({
	providedIn: 'root'
})
export class DealerService extends AuthorityBaseService {

	constructor(protected injector: Injector) {
		super(injector);
	}

	getBaseURL(x?: boolean | DossierModel | Object): string {

		if (Utilities.isEmpty(x) || x === false) {
			return this.environment.api.authority.v1;
		}

		if (x == true) {
			return this.environment.api.authority.historical.v1;
		}
		
		if (x instanceof DossierModel) {

			return x && x.isArchived && x.isArchived() ? this.environment.api.authority.historical.v1 : this.environment.api.authority.v1;
		}
		
		return this.environment.api.authority.v1;
		// return x && x.hasOwnProperty('archived') && x.archived == true ? this.environment.api.authority.historical.v1 : this.environment.api.authority.v1;
		// return x && x.archived && x.archived == true ? this.environment.api.authority.historical.v1 : this.environment.api.authority.v1;
	}
	
	getDealer(
		dossier: DossierModel, 
		working_id: string, 
		quotation_id: string, 
		entry_id: string,
		onSuccess: (dealer: CommodityModel) => void, 
		onFailure: (message: MessageDetail) => void
	): void {
		// const url: string = this.environment.AUTHORITY + '/dossiers/' + dossier_id + '/workings/' + working_id + '/quotations/' + quotation_id + '/entries/' + entry_id + '/dealer';
		const url: string = this.getBaseURL(dossier) + '/dossiers/' + dossier.id + '/workings/' + working_id + '/quotations/' + quotation_id + '/entries/' + entry_id + '/dealer';
		this.httpAuthService.get(url, this.redirectUrl).subscribe(
			response => {
				const responseParsed: any = response.json();
				if (response.ok) {
					try {
						onSuccess(new CommodityModel(responseParsed));
					} catch (error) {
						onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(responseParsed));
					}
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(responseParsed));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			});
	}

	setDealerByEntry(dossier_id: string, working_id: string, quotation_id: string, entry_id: string, dealer_id: string, commodities: string[],
						onSuccess: (successMessage: MessageDetail) => void, onFailure: (failureMessage: MessageDetail) => void): void {
		const url: string = this.environment.AUTHORITY + '/dossiers/' + dossier_id + '/workings/' + working_id + '/quotations/' +
			quotation_id + '/entries/' + entry_id + '/dealer';
		const body: DealerRequestBody = {
			dealer_id: dealer_id
		};
		const options: RequestOptionsArgs = Utilities.setOptionsWithNemoCommodityID(commodities);
		this.dealerServiceDoPatch(url,body,options,onSuccess,onFailure, MessageComponentType.FLASH_MESSAGE);
	}

	setSlaDealerByElapsedOrderId(dossier_id: string, working_id: string, quotation_id: string, entry_ids: string[], dealer_id: string, commodities: string[],
								onSuccess: (successMessage: MessageDetail) => void, onFailure: (failureMessage: MessageDetail) => void): void {
		const url: string = this.environment.AUTHORITY + '/dossiers/' + dossier_id + '/workings/' + working_id + '/quotations/' +
			quotation_id + '/entries/dealer/sla';
		const body: DealerRequestBody = {
			dealer_id: dealer_id,
			entry_ids: entry_ids
		};
		const options: RequestOptionsArgs = Utilities.setOptionsWithNemoCommodityID(commodities);
		this.dealerServiceDoPatch(url,body,options,onSuccess,onFailure, MessageComponentType.SNACK_BAR);
	}

	setDealerByEntries(dossier_id: string, working_id: string, quotation_id: string, entry_ids: string[], dealer_id: string, commodities: string[],
						onSuccess: (successMessage: MessageDetail) => void, onFailure: (failureMessage: MessageDetail) => void): void {
		const url: string = this.environment.AUTHORITY + '/dossiers/' + dossier_id + '/workings/' + working_id + '/quotations/' +
			quotation_id + '/entries/dealer';
		const body: DealerRequestBody = {
			dealer_id: dealer_id,
			entry_ids: entry_ids
		};
		const options: RequestOptionsArgs = Utilities.setOptionsWithNemoCommodityID(commodities);

		this.dealerServiceDoPatch(url, body, options, onSuccess, onFailure, MessageComponentType.SNACK_BAR);
	}

	getOrderSummary(order_id: string): Observable<OrderSummary> {
		const url: string = this.environment.AUTHORITY + '/orders/' + order_id + '/summary';
		return this.httpAuthService.get(url, this.redirectUrl).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}), map(response => response.json()),
			catchError((error: Response) => {
				this.messageManagerService.pushInnerMessage(MessageManagerUtilities.getMessageDetailsFromResponse(error));
				return throwError(error);
			}
		));
	}

	private dealerServiceDoPatch(url: string, body: any, options: RequestOptionsArgs, onSuccess: (successMessage: MessageDetail) => void, onFailure: (failureMessage: MessageDetail) => void,  componentType: MessageComponentType): void {
		this.httpAuthService.patch(url, body, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					onSuccess({
						code: InnerMessageAuthorityMessageCode.AUTHORITY_SUCCESS_UPDATE_DEALER,
						type: MessageType.TYPE_SUCCESS,
						componentType: componentType
					});
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}
}


interface DealerRequestBody {
	dealer_id: string;
	entry_ids?: string[];
}
